import styled from 'styled-components';

export default styled.span`
	display: inline-block;
	position: relative;
	vertical-align: top;
	font-size: var(--px-14);
	.motif-checkbox {
		.motif-checkbox-label {
			width: ${(props) => props.customLabelWidth};
			z-index: 2;
			.checkboxLabel {
				display: flex;
				align-items: center;
			}
		}
	}
	.motif-checkbox-label-wrap {
		margin-bottom: 0;
		position: relative;
	}
`;
